import React from "react";

const columns = () => {
    return [
        {
            name: "id",
            formItem: {
                type: "hidden"
            }
        },
        {
            title: '标题',
            name: 'title',
            tableItem: {
                width: 400
            },
            searchItem: {}
        },
        {
            name: "releaseState",
            title: "发布状态",
            dataIndex: "releaseState",
            tableItem: {
                width: 100
            },
            dict: [
                { code: 0, codeName: "草稿" },
                { code: 1, codeName: "已发布" },
                { code: 2, codeName: "已结束" },
                { code: 3, codeName: "已关闭" },
            ],
        },
        {
            name: 'categoryNames',
            title: '内容分类',
            dataIndex: 'categoryNames',
            tableItem: {},
        },
        {
            title: "内容类型",
            name: "contentType",
            dataIndex: "contentType",
            tableItem: {
                width: 100,
            },
            searchItem: {
                type: "select",
            },
            dict: [
                { code: 1, codeName: "文章" },
                { code: 2, codeName: "图片" },
                { code: 3, codeName: "视频" },
                // { code: 4, codeName: "文档" },
                { code: 5, codeName: "下载" },
            ],
        },
        {
            title: "发布平台",
            name: "releasePlatform",
            dataIndex: "releasePlatform",
            tableItem: {
                width: 230,
                render: (text, record) => {
                    const map = { '1': "PC", '2': 'APP', '3': '企业号', '4': '小程序' }
                    const textArr = text.split(',');
                    const arr = [];
                    for (let index = 0; index < textArr.length; index++) {
                        arr.push(map[textArr[index]])
                    }
                    return arr.join(',')
                }
            },
            searchItem: {
                type: 'select'
            },
            dict: [
                { code: 1, codeName: "PC" },
                { code: 2, codeName: "APP" },
                // { code: 3, codeName: "企业号" },
                // { code: 4, codeName: "小程序" },
            ],
        },
    ]
  }
  
  const tableApi = (api = {}) => {
    return {
      path: 'contentManage/listByPage',
      ...api
    }
  }
  
  const content = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'id',
        rowName: 'title',
        columns: columns(),
        tableApi: tableApi(api)
    }
  }
  
  export default content
